import { TastesLike, Taste } from "@/models/wine";
import { Heading, Text } from "@/components/Typography";
import HtmlParser from "@/components/HtmlParser";
import { FlexColumn } from "@/components/layout/FlexBox";

import s from "./TastesLike.module.scss";

interface Props {
	data: TastesLike;
	title?: string;
}

export function TastesLike({ data, title }: Props) {
	return (
		<section className={s.section}>
			<Heading as="h2" sizeMobile="xl" sizeDesktop="xl" className={s.heading}>
				{data.title ? data.title : title}
			</Heading>
			<Text className={s.intro}>
				<HtmlParser content={data.introduction} />
			</Text>
			<FlexColumn gap={32} className={s.items}>
				{data?.tastes?.map((t) => (
					<Item key={t.name} {...t} />
				))}
			</FlexColumn>
		</section>
	);
}

function Item({ name, min_label, max_label, value }: Taste) {
	const activeBar = parseInt(value);
	return (
		<FlexColumn gap={16} className={s.item}>
			<Heading as="h3" sizeMobile="sm" sizeDesktop="sm">
				{name}
			</Heading>
			<div className={s.item_row}>
				<Heading
					as="h4"
					sizeDesktop="xs"
					sizeMobile="xs"
					className={s.min_label}
				>
					{min_label}
				</Heading>
				<div className={s.bars}>
					<div className={s.bar} style={{ gridColumnStart: activeBar }}></div>
				</div>
				<Heading
					as="h4"
					sizeDesktop="xs"
					sizeMobile="xs"
					className={s.max_label}
				>
					{max_label}
				</Heading>
			</div>
		</FlexColumn>
	);
}
